import { Backdrop } from '@material-ui/core'
import Progress from 'components/Progress'
import { processandoDados } from 'helpers/Constantes/Mensagens'
import * as S from './index.style'

export type ModalProgressProps = {
  visivel: boolean
}

const ModalProgress: React.FC<ModalProgressProps> = ({ visivel }) => (
  <Backdrop data-cy="modalProgress" style={{ zIndex: 999 }} open={visivel}>
    <S.PopUp>
      <Progress sizeCircularProgress={50} label={processandoDados}></Progress>
    </S.PopUp>
  </Backdrop>
)

export default ModalProgress
